export function cronLogsOpsReducer(state, action) {
	const stateClone = Object.assign({}, state);

	switch(action.type) {
		case 'INC_SKIP':
			stateClone.skip = stateClone.skip + 1;
			break;
		case 'DEC_SKIP':
			stateClone.skip = Math.max(0, stateClone.skip - 1);
			break;
		case 'TO_PAGE':
			stateClone.skip = Math.max(0, action.payload);
			break;
		default:
			break;
	}

	return stateClone;
};
